/**
 * @file Image Upload component
 *
 * This component will have a clickable button that will scroll the page back to the top.
 */
import SelectorEngine from '../../../client/utils/dom/selector-engine';
import Manipulator from '../../../client/utils/dom/manipulator';
import EventHandler from '../../utils/dom/event-handler';
import ImageCropper from '../ImageCropper';
import BaseComponent from '../BaseComponent';

const NAME = 'ImageUpload';

export class ImageUpload extends BaseComponent {
	constructor(element) {
		super(element);
		this.uploadedImage = undefined;
		if(!this._element) { return;}
		this.init();
	}

	static get NAME() {
		return NAME;
	}

	init() {
		this.inputFile = SelectorEngine.findOne('#lta-upload-image', this._element);
		if(!this.inputFile) { return; }

		this.uploadedImage = SelectorEngine.findOne('.lta-uploaded-avatar', this._element);
		if(!this.uploadedImage) { return; }

		this.croppingImageElement = SelectorEngine.findOne('img.lta-avatar--with-image-crop', this.uploadedImage);
		if(!this.croppingImageElement) { return; }
		
		const fromPage = Manipulator.getDataAttribute(this.uploadedImage, 'from-page');
		
		EventHandler.on(this.inputFile, 'change', (event) => {
			this.createFileInput(event, fromPage);
		});

	}

	createFileInput(event, page) {
		// Get the selected file from the input
		const selectedFile = event.target.files[0];
		if (!(page === 'editProfile')) {
			this.executeUpload(selectedFile);
		} else {
			if (Number(selectedFile.size) < 5_242_880) {
				this.executeUpload(selectedFile);
			}
		}
	}

	executeUpload(selectedFile) {
		const reader = new FileReader();
		reader.addEventListener('load', (e) => {

			// Replacing exisitng image.
			this.uploadedImage.querySelector('img').src = e.target.result;

			if(this.croppingImageElement) {
				this.initCropper();
			}
		});
		reader.readAsDataURL(selectedFile);
	}

	initCropper() {
		// Initialize the image cropper component.
		this.cropperInstance = ImageCropper.getOrCreateInstance(this.croppingImageElement);

		// Calling init method of image cropper.
		this.cropperInstance.init();
	}

	updateImage() {
		this.uploadedImage.querySelector('img').src = URL.createObjectURL(this.inputFile.files[0]);
	}

	updateFile(file) {
		const container = new DataTransfer();
		container.items.add(file);
		this.inputFile.files = container.files;
	}

	async cropHandler(cb) {
		if(!this.cropperInstance) { 
			cb(); 
			return; 
		}
		try {
			const fileName = this.inputFile.files[0]?.name;
			const file = await this.cropperInstance.getImageFile(fileName);
			this.updateFile(file);
			this.updateImage();
			if(typeof cb === "function") {
				cb();
			}
			this.cropperInstance.destroy();
			this.cropperInstance = null;
		} catch(error) {
			console.error(error);
		}
	}
}

const element = SelectorEngine.findOne('#lta-image-upload-form');
const imageUpload = ImageUpload.getOrCreateInstance(element);

export default imageUpload;
